/** Palette of distinct, accessible colors for speaker differentiation */
const PALETTE: readonly string[] = [
	'#8c52ff',
	'#2563eb',
	'#059669',
	'#dc2626',
	'#ea580c',
	'#0891b2',
	'#7c3aed',
	'#db2777',
	'#0d9488',
	'#4f46e5',
	'#b91c1c',
	'#ca8a04',
	'#047857',
	'#be185d',
	'#6366f1',
	'#0e7490',
]

/** Stable hash for string → color assignment. Same name always returns same color. */
function hashToIndex(str: string): number {
	let hash = 0
	for (let i = 0; i < str.length; i++) {
		hash = ((hash << 5) - hash + str.charCodeAt(i)) | 0
	}
	return Math.abs(hash)
}

/** Returns a deterministic color for a speaker. Same speaker name → same color across the transcript. */
export function getColorForSpeaker(speaker: string): string {
	const key = speaker.trim() || '\0'
	return PALETTE[hashToIndex(key) % PALETTE.length]
}
